import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Iframe from 'react-iframe'

const styles = {
 
    card2: {
        alignItems:'center',
        align: 'center',
        boxShadow: 'none',
        border:'none',
        // height:'100%',
        // width:'100vw',
        // minHeight: 700,
        // minWidth: 725,
        // marginLeft:'auto',
        // marginRight: 'auto'
    },
    myClassname:{

    }
  };

class ChatBox_award extends Component {

    state={
        height:'30vh',
        width:'30vw'
    }

    componentDidMount(){
        setInterval(()=>{
            this.setState({
                height:'100vh',
                width:'95vw'
            })
        },3000)
    }

    render(){
        
        const { classes, src } = this.props; 
        console.log('ChatBox_award caseId: '+this.props.caseId);        
        let fileURL = __dirname + 'chatbot_award_other_chi.html?caseId='+this.props.caseId
     
        if (this.props.isDesktop){
            return(
                <div style={{ height:this.state.height, width:this.state.width}}>
                    <Iframe 
                        url={fileURL}
                        position="center"
                        // width="60%"
                        // height="100%"
                        // height="100%"
                        id="myId"
                        className="myClassname"
                        />
                </div>
            );
        }
        else{
            return(
                <div style={{ height:this.state.height, width:this.state.width}}>
                    <Iframe 
                        url={fileURL}
                        position="center"
                        // width="60%"
                        // height="100%"
                        // height="100%"
                        id="myId"
                        className="myClassname"
                        />
                </div>
            );
        }
        
        
    }
}

export default withStyles(styles)(ChatBox_award);